import { render } from "./StudentSkillAssessmentDataTable.vue?vue&type=template&id=321da50d&scoped=true"
import script from "./StudentSkillAssessmentDataTable.vue?vue&type=script&lang=js"
export * from "./StudentSkillAssessmentDataTable.vue?vue&type=script&lang=js"

import "./StudentSkillAssessmentDataTable.vue?vue&type=style&index=0&id=321da50d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-321da50d"]])

export default __exports__